import { useState, useCallback } from "react";
import { memoryStore, setItemImmediate } from "../utils/storage";

const KEY       = "pension_settings_v1";
const PHOTO_KEY = "pension_license_photo_v1";
const SIG_KEY   = "pension_license_sig_v1";

const DEFAULTS = {
  contactEmail: "",
  contactPhone: "",
  emailProvider: "gmail",
  licenseNumber: "",
  licenseType: "agent",
  licenseName: "",
  licenseId: "",
  licenseMobile: "",
  licensePhone: "",
  licenseEmail: "",
  opContactName: "",
  opContactPhone: "",
  opContactEmail: "",
  // licensePhotoDataUrl and signatureDataUrl are stored separately —
  // they are large blobs and should not pollute the settings JSON.
};

function readSettings() {
  try {
    const raw = memoryStore.getItem(KEY);
    const base = raw ? { ...DEFAULTS, ...JSON.parse(raw) } : { ...DEFAULTS };
    // migrate old data that was stored inline
    if (base.licensePhotoDataUrl) {
      setItemImmediate(PHOTO_KEY, base.licensePhotoDataUrl);
      delete base.licensePhotoDataUrl;
      setItemImmediate(KEY, JSON.stringify(base));
    }
    if (base.signatureDataUrl) {
      setItemImmediate(SIG_KEY, base.signatureDataUrl);
      delete base.signatureDataUrl;
      setItemImmediate(KEY, JSON.stringify(base));
    }
    return {
      ...base,
      licensePhotoDataUrl: memoryStore.getItem(PHOTO_KEY) || "",
      signatureDataUrl:    memoryStore.getItem(SIG_KEY)   || "",
    };
  } catch { return { ...DEFAULTS, licensePhotoDataUrl: "", signatureDataUrl: "" }; }
}

export function useSettingsStore() {
  const [settings, setSettings] = useState(readSettings);

  const saveSettings = useCallback((updates) => {
    const next = { ...settings, ...updates };

    // blobs go to their own keys; rest goes to main settings key
    const { licensePhotoDataUrl, signatureDataUrl, ...rest } = next;

    setSettings(next);
    setItemImmediate(KEY, JSON.stringify(rest));

    if ("licensePhotoDataUrl" in updates) setItemImmediate(PHOTO_KEY, licensePhotoDataUrl || "");
    if ("signatureDataUrl"    in updates) setItemImmediate(SIG_KEY,   signatureDataUrl    || "");
  }, [settings]);

  return { settings, saveSettings };
}

// Helper for server-side API calls (e.g. מסלקה integration)
export function getLicensePhoto() {
  return memoryStore.getItem(PHOTO_KEY) || "";
}

export function getLicenseSignature() {
  return memoryStore.getItem(SIG_KEY) || "";
}
